var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessageCircle = function SvgMessageCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.005 21.01c-.28 0-.55-.12-.75-.33a.98.98 0 0 1-.2-.98l1.15-3.45c-2.28-3.83-1.2-8.62 2.62-11.33 3.87-2.75 9.49-2.52 13.07.53 3.67 3.13 4.16 8.24 1.15 11.9-2.87 3.48-8.17 4.61-12.46 2.71l-4.37.93c-.07.01-.14.02-.21.02m4.7-3c.15 0 .3.03.44.1 3.54 1.72 8 .85 10.37-2.03 2.34-2.83 1.95-6.66-.91-9.1-2.9-2.48-7.47-2.66-10.62-.43-3.11 2.2-3.88 5.99-1.85 9 .17.26.22.58.12.88l-.75 2.24 2.99-.64c.07-.01.14-.02.21-.02"
  })));
};
export default SvgMessageCircle;